import { NgModule } from '@angular/core';

import { AdalService } from './../services/adal.service';

@NgModule({
    imports: [],
    exports: [],
    declarations: [],
    providers: [AdalService],
})
export class AdalModule { }
